import axios from 'axios';

// Separate axios instance for Longdo API — does NOT inherit axios.defaults
// (axios.defaults sets X-Requested-With globally which causes CORS preflight failure on Longdo API)
const longdoAxios = axios.create();
if (longdoAxios.defaults.headers && longdoAxios.defaults.headers.common) {
    delete longdoAxios.defaults.headers.common['X-Requested-With'];
}

export default longdoAxios;
